export const formSubmitEndpoint = process.env.REACT_APP_ENV === "production"
  ? process.env.REACT_APP_CONTACT_FORM_ENDPOINT?.trim()
  : undefined;
